











import Vue from 'vue'
import { firestore } from '../firebase'
export default Vue.extend({
  name: 'home',
  data: () => {
    return {
      leaders: [] as any[],
      unsubscribe: () => { }
    }
  },
  created () {
    this.unsubscribe = firestore().collection('users').orderBy('points', 'desc').limit(10).onSnapshot(snap => {
      if (snap.size) {
        const leaders = snap.docs.map(leader => {
          return {
            name: leader.data().displayName,
            points: leader.data().points
          }
        })
        this.leaders = leaders
      }
    })
  }
})
